import { isAnonymousParticipantToken } from '@/src/network/authExchange';
import { isEmbeddedByAnotherOrigin, isInIframe } from '@/utils/isInIframe';
import { TypedStorage } from '@/utils/TypedStorage';

/**
 * The participant app's iframe runs on the token it hands over, never Kinde's: Kinde there can be another user,
 * or reset and leave `getToken` empty. Same-origin frames are sessions' previews, where only an anonymous token
 * wins. The URL check covers the time before `AuthTokenProvider` stores the token.
 */
export const hasEmbeddedParticipantSession = (): boolean => {
  if (!isInIframe()) {
    return false;
  }
  const token = new URLSearchParams(window.location.search).get('userToken') ?? TypedStorage.get('viewer_jwt');
  return !!token && (isAnonymousParticipantToken(token) || isEmbeddedByAnotherOrigin());
};
